// extracted by mini-css-extract-plugin
export default {"headerBar":"EditEmployee_headerBar__hLcgn"};